export default __webpack_public_path__ + "static/media/capstone-client.b0928d24.svg";